module.exports = __webpack_public_path__ + "static/media/gift-peach.66433015.svg";